import React from "react";

export function PublicJobPagePreview({ customStyle }: { customStyle: any }) {
  const mainColor = customStyle?.mainColor || '#2563eb';
  const bgColor = customStyle?.bgColor || '#f3f4f6';
  const logoUrl = customStyle?.logoUrl;
  const pageStyle = customStyle?.pageStyle || 'rounded';
  const borderRadius = pageStyle === 'square' ? '0' : '1rem'; // 1rem = rounded-sm
  const job = {
    title: customStyle?.title || 'Frontend Developer',
    org_name: 'Acme Corp',
    jobdesc_public: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur lacinia nisl eget sapien interdum pretium.',
    location: 'Remote',
    created_at: '2024-06-01',
  };
  return (
    <div style={{ background: bgColor, minHeight: 400, borderRadius: pageStyle === 'square' ? '0' : '0.75rem' }} className="shadow p-6">
      <div className="max-w-3xl mx-auto">
        {logoUrl && (
          <img src={logoUrl} alt="Logo" className="mb-6 block" style={{ maxHeight: 48, width: 'auto', maxWidth: '100%' }} />
        )}
        <div className="bg-white shadow-xl p-8 border border-gray-200" style={{ borderRadius }}>
          <div className="mb-8">
            <a
              href="#"
              className="inline-flex items-center font-medium mb-6"
              style={{ color: mainColor }}
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Voir toutes les offres de {job.org_name}
            </a>
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-1 leading-tight">{job.title}</h1>
              <div className="text-lg md:text-xl font-semibold mb-2" style={{ color: mainColor }}>{job.org_name}</div>
            </div>
          </div>
          <div className="prose max-w-none mb-0 text-gray-800" style={{ fontSize: '1.08rem' }}>{job.jobdesc_public}</div>
        </div>
      </div>
    </div>
  );
} 